<template>
  <base-modal :box="box_init" :step="step">
    <template slot="description">
      <div>
        {{ $t('pbx.worksheet.action.list.state.init.description') }}
        <router-link :to="{ name: 'pbx.service-package.index' }">
          <span @click="$refs.close.$el.click()"> {{ $t('pbx.breadcrumb.title') }} </span>
        </router-link>
        -
        <router-link :to="{ name: 'pbx.phone-list.index' }">
          <span @click="$refs.close.$el.click()">
            {{ $t('pbx.breadcrumb.phone-list.index') }}
          </span>
        </router-link>
      </div>
    </template>
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group class="row">
        <div class="col-4 text-right">
          {{ $t('pbx.worksheet.action.list.input.list_id.label') }}
        </div>
        <z-form-input
          class="col-8"
          :rules="{ required: true }"
          :name="$t('pbx.worksheet.action.list.input.list_id.label')"
        >
          <i-select
            :value="form.params.list_id"
            :filterable="true"
            :clearable="true"
            @on-select="select"
            @on-clear="form.params.list_id = null"
          >
            <i-option v-for="item in items" :key="item.id" :value="item.id" :label="item.name">
              <div class="phone-list-select">
                <div class="phone-list-select__name">
                  {{ item.name }}
                </div>
                <div class="phone-list-select__time">
                  {{ item.updated_at }}
                </div>
              </div>
            </i-option>
          </i-select>
        </z-form-input>
      </z-form-group>
    </z-form>
    <i-button slot="footer-cancel" slot-scope="{ close }" size="large" @click="close()" ref="close">
      {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
    </i-button>
    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import { StepMixin } from '../../../_base/step-mixin';
  import { PhoneListService } from '@pbx/services/PhoneListService';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal, FormInputName },
    mixins: [StepMixin],

    data() {
      return {
        items: []
      };
    },

    async created() {
      this.items = await PhoneListService.getSelect();
    },

    methods: {
      select: function (item) {
        this.form.params.list_id = item.value;
      },
      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .phone-list-select {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    &__time {
      color: #ccc;
      font-size: 12px;
      margin-top: 5px;
    }
  }
</style>
